// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import { faCheck, faCloudDownloadAlt, faCloudUploadAlt, faDesktop, faEnvelope, faImage, faInfoCircle, faTimesCircle, faPlusCircle, faSignOutAlt, faAddressCard, faHome, faStickyNote, faPhotoVideo, faShareAlt, faUserEdit} from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(
  fab,
  faAddressCard,
  faCheck,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faDesktop,
  faEnvelope,
  faImage,
  faInfoCircle,
  faHome,
  faPhotoVideo,
  faPlusCircle,
  faShareAlt,
  faSignOutAlt,
  faStickyNote,
  faTimesCircle,
  faUserEdit,
  // more icons go here
);